import { ActionIcon, Text } from "@mantine/core";
import StarRounded from "@mui/icons-material/StarRounded";
import clsx from "clsx";
import { deckReviewCardsAction } from "../../../../../../../../../../features/flashcards/subjectFlashcardsSlice";
import { useCustomDispatch } from "../../../../../../../../../../lib/redux/hooks";
import classes from "./CardButtons.module.css";

export default function CardButtons({
  subjectDocumentId,
  deckDocumentId,
  handleFlashcardAttempt,
  cardDocumentId,
  front,
  saved,
  disableActions,
}: {
  subjectDocumentId: string;
  deckDocumentId: string;
  handleFlashcardAttempt: (isStarAction: boolean) => void;
  cardDocumentId: string;
  front: boolean;
  saved: boolean;
  disableActions: boolean;
}) {
  const dispatch = useCustomDispatch();
  return (
    <>
      <Text className={classes.sideIndicator}>{front ? "Front" : "Back"}</Text>
      <ActionIcon
        className={clsx(
          classes.reviewIndicator,
          saved && classes.reviewIndicatorSaved
        )}
        title="Review"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            deckReviewCardsAction({
              subjectDocumentId,
              deckDocumentId,
              cardDocumentId,
            })
          );
          // only track save action if not preview/disabled and not already set to saved
          if (!saved && !disableActions) {
            handleFlashcardAttempt(true);
          }
        }}
      >
        <StarRounded style={{ width: "1rem", height: "1rem" }} />
      </ActionIcon>
    </>
  );
}
